import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { bannerSlides } from "@/mocks/products";

export default function BannerCarousel() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % bannerSlides.length);
  }, []);

  const prev = () => {
    setCurrent((prev) => (prev - 1 + bannerSlides.length) % bannerSlides.length);
  };

  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <div className="relative w-full overflow-hidden" style={{ height: "260px" }}>
      <style>{`@media (min-width: 768px) { .banner-wrap { height: 420px !important; } }`}</style>
      <div className="banner-wrap absolute inset-0" style={{ height: "260px" }}>
        {bannerSlides.map((slide, idx) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${idx === current ? "opacity-100 z-10" : "opacity-0 z-0"}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/35 to-transparent"></div>
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-7xl mx-auto px-5 md:px-8 w-full">
                <span className="inline-block bg-red-500 text-white text-xs px-2.5 py-0.5 rounded-full mb-2 md:mb-3 font-medium">
                  {slide.tag}
                </span>
                <h2 className="text-white text-xl md:text-4xl font-bold mb-1.5 md:mb-3 leading-tight" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                  {slide.title}
                </h2>
                <p className="text-white/80 text-sm md:text-lg mb-3 md:mb-6 max-w-xs md:max-w-md line-clamp-2 md:line-clamp-none">
                  {slide.subtitle}
                </p>
                <button
                  onClick={() => navigate(slide.link || "/products")}
                  className="px-5 md:px-8 py-2 md:py-3 rounded-md font-bold transition-all cursor-pointer whitespace-nowrap text-sm bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-500 hover:from-amber-500 hover:via-yellow-500 hover:to-amber-600 text-gray-900"
                >
                  {slide.cta} <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={prev}
        className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-black/30 hover:bg-black/50 text-white rounded-full cursor-pointer transition-colors"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-black/30 hover:bg-black/50 text-white rounded-full cursor-pointer transition-colors"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      {/* Dots */}
      <div className="absolute bottom-10 md:bottom-12 left-1/2 -translate-x-1/2 z-20 flex items-center gap-1.5">
        {bannerSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`transition-all duration-300 rounded-full cursor-pointer ${idx === current ? "w-5 h-1.5 bg-white" : "w-1.5 h-1.5 bg-white/50"}`}
          />
        ))}
      </div>

      {/* Gold brand tagline banner */}
      <div className="absolute bottom-0 left-0 right-0 z-20 bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-500 py-1.5 md:py-2 px-3 md:px-4 overflow-hidden">
        <div className="max-w-7xl mx-auto flex items-center gap-3 md:gap-4 overflow-x-auto scrollbar-hide">
          <div className="flex items-center gap-1.5 flex-shrink-0">
            <i className="ri-vip-crown-fill text-gray-900 text-sm"></i>
            <span className="text-gray-900 font-bold text-xs whitespace-nowrap" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              皇冠鸿运商城
            </span>
          </div>
          <div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
            {[
              { icon: "ri-shield-check-line", text: "正品直营" },
              { icon: "ri-truck-line", text: "极速配送" },
              { icon: "ri-medal-line", text: "达人返佣" },
              { icon: "ri-heart-line", text: "爱心捐赠" },
              { icon: "ri-book-open-line", text: "教育书籍" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-1 text-gray-800 text-xs font-medium whitespace-nowrap">
                <i className={`${item.icon} text-gray-900 text-xs`}></i>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
